export enum SourceDomain {
  VpaApply,
  AdditionalVpa
}
